/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NatureFxSparkleA3Icon16Light } from './NatureFxSparkleA3Icon16Light';
import { NatureFxSparkleA3Icon16Regular } from './NatureFxSparkleA3Icon16Regular';
import { NatureFxSparkleA3Icon16Solid } from './NatureFxSparkleA3Icon16Solid';
import { NatureFxSparkleA3Icon20Light } from './NatureFxSparkleA3Icon20Light';
import { NatureFxSparkleA3Icon20Regular } from './NatureFxSparkleA3Icon20Regular';
import { NatureFxSparkleA3Icon20Solid } from './NatureFxSparkleA3Icon20Solid';
import { NatureFxSparkleA3Icon24Regular } from './NatureFxSparkleA3Icon24Regular';
import { NatureFxSparkleA3Icon24Solid } from './NatureFxSparkleA3Icon24Solid';
import { NatureFxSparkleA3Icon32Regular } from './NatureFxSparkleA3Icon32Regular';
import { NatureFxSparkleA3Icon64Regular } from './NatureFxSparkleA3Icon64Regular';
var sizes = {
    16: {
        light: NatureFxSparkleA3Icon16Light,
        regular: NatureFxSparkleA3Icon16Regular,
        solid: NatureFxSparkleA3Icon16Solid,
    },
    20: {
        light: NatureFxSparkleA3Icon20Light,
        regular: NatureFxSparkleA3Icon20Regular,
        solid: NatureFxSparkleA3Icon20Solid,
    },
    24: {
        regular: NatureFxSparkleA3Icon24Regular,
        solid: NatureFxSparkleA3Icon24Solid,
    },
    32: {
        regular: NatureFxSparkleA3Icon32Regular,
    },
    64: {
        regular: NatureFxSparkleA3Icon64Regular,
    },
};
export var NatureFxSparkleA3Icon = forwardRef('NatureFxSparkleA3Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
